import * as types from './types';
import instance from '../../services/api';

export const setLoading = (loading) => ({
  type: types.MENU_OPTIONS_LOADING,
  payload: loading,
});

export const setError = (businessId, error) => ({
  type: types.MENU_OPTIONS_ERROR,
  payload: { businessId, error },
});

// Standard menu sections for the promotion and coupon target pickers, from the
// same categories-by-menu endpoint the menu screens are served by. A failure is
// kept on the slice against the business it was attempted for, so the pickers
// render empty and the request is not repeated on every re-render.
export const fetchMenuSections = (businessId) => (dispatch) => {
  dispatch(setLoading(true));
  return instance
    .get('/categories/menu/main')
    .then(({ data: { data } }) => {
      dispatch({
        type: types.MENU_OPTIONS_SET,
        payload: { businessId, sections: data || [] },
      });
      dispatch(setLoading(false));
      return data;
    })
    .catch((error) => {
      dispatch(setError(businessId, error.message));
      dispatch(setLoading(false));
      return null;
    });
};
